import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './irlTool.scss';

import { getCurrentOrder } from '../../store/slices/order.slice';

interface props {
  isQuizOnly?: boolean;
  isQuizShow?: boolean;
  prescription?: any;
  click?: () => void;
  lensSelected?: (data: any) => void;
}
const IrlTool: React.FC<props> = ({
  isQuizOnly = false,
  isQuizShow = false,
  prescription = null,
  click,
  lensSelected,
}) => {
  const {
    order: { frame },
  } = useSelector(getCurrentOrder);

  const irlRootRef = React.createRef<HTMLElement>();
  const irlQuizRef = React.createRef<any>();

  const [isListenerAdded, setIsListernerAdded] = useState(false);

  useEffect(() => {
    irlRootRef.current?.addEventListener('clicked', () => {
      if (click) click();
    });
  }, [click, irlRootRef]);

  useEffect(() => {
    if (irlQuizRef.current && !isListenerAdded) {
      const irlQuizEl = irlQuizRef.current;

      irlQuizEl.addEventListener('lensSelected', e => {
        if (lensSelected) lensSelected(e.detail);
      });

      setIsListernerAdded(true);
    }
  }, [isListenerAdded]);

  useEffect(() => {
    if (irlQuizRef && irlQuizRef.current && frame && prescription) {
      irlQuizRef.current.userData = {
        lensType: 'clear',
        frame: {
          frameId: frame.id,
          frameName: frame.modelName,
          framePrice: frame.price,
          fitMixId: frame.code,
          imageUrl: frame.previews[0],
          lensColor: [],
        },
        prescription: {
          right: {
            sph: prescription.right.sphere,
            cyl: prescription.right.cylinder || 0,
            axi: prescription.right.axis || 0,
            add: prescription.right.addition || 0,
          },
          left: {
            sph: prescription.left.sphere,
            cyl: prescription.left.cylinder || 0,
            axi: prescription.left.axis || 0,
            add: prescription.left.addition || 0,
          },
          pd: prescription.pupillaryDistance,
        },
      };

      if (isQuizShow) {
        irlQuizRef.current.show();
      }
    }
  }, [isQuizShow, prescription]);

  return (
    <div className="irl">
      {!isQuizOnly ? <irl-tool ref={irlRootRef} /> : <irl-quiz ref={irlQuizRef} />}
    </div>
  );
};

export default IrlTool;
